import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAdmin } from '../context/AdminContext';

import { API } from '../config/api';
import { apiFetch } from '../config/http';

const CATEGORIAS_DEFAULT = [
  'Topografía','Tecnología','Seguros','Hidrología',
  'Vial','Arquitectura','Contabilidad','Transporte','Hospedaje'
];

const BANCOS = ['BAC','BCR','BNCR','Davivienda','BN','Scotiabank','Promerica','Lafise','Cathay','Otro'];

const EMPTY = {
  razon_social:'', cedula:'', correo_comprobante:'', telefono:'',
  direccion:'', nombre_contacto:'', correo_contacto:'', telefono_contacto:'', banco:'',
  categoria:'', cuenta_crc:'', iban_crc:'', cuenta_usd:'', iban_usd:''
};

const inputStyle = {
  padding:'8px 12px', border:'1px solid #e0e0e0', borderRadius:'8px',
  fontSize:'13px', outline:'none', width:'100%', boxSizing:'border-box',
  fontFamily:'Segoe UI, sans-serif'
};

const catBadge = (cat) => (
  <span style={{ background:'#e6f1fb', color:'#185FA5', padding:'2px 8px', borderRadius:'8px', fontSize:'11px', fontWeight:'500' }}>
    {cat || '—'}
  </span>
);

function ModalEliminar({ proveedor, onConfirm, onCancel }) {
  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.35)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000 }}>
      <div style={{ background:'#fff', borderRadius:'14px', padding:'28px', width:'380px', boxShadow:'0 8px 32px rgba(0,0,0,0.15)' }}>
        <div style={{ width:'52px', height:'52px', background:'#FCEBEB', borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 16px' }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6" stroke="#A32D2D" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <h3 style={{ textAlign:'center', fontSize:'16px', fontWeight:'700', color:'#1a1a1a', margin:'0 0 8px' }}>Eliminar proveedor</h3>
        <p style={{ textAlign:'center', fontSize:'13px', color:'#666', margin:'0 0 20px', lineHeight:'1.5' }}>
          ¿Eliminar permanentemente a <strong>{proveedor?.razon_social}</strong>?<br/>
          Esta acción <strong>no se puede deshacer</strong>.
        </p>
        <div style={{ display:'flex', justifyContent:'flex-end', gap:'10px' }}>
          <button onClick={onCancel} style={{ padding:'8px 20px', border:'1px solid #e0e0e0', borderRadius:'8px', background:'#fff', cursor:'pointer', fontSize:'13px' }}>Cancelar</button>
          <button onClick={onConfirm} style={{ padding:'8px 20px', background:'#A32D2D', color:'#fff', border:'none', borderRadius:'8px', fontSize:'13px', fontWeight:'600', cursor:'pointer' }}>Sí, eliminar</button>
        </div>
      </div>
    </div>
  );
}

export default function Proveedores() {
  const isAdmin = useAdmin();

  const [lista, setLista]                 = useState([]);
  const [filtro, setFiltro]               = useState('');
  const [vistaActivos, setVistaActivos]   = useState(true);
  const [modal, setModal]                 = useState(false);
  const [detalle, setDetalle]             = useState(null);
  const [form, setForm]                   = useState(EMPTY);
  const [editando, setEditando]           = useState(false);
  const [cargando, setCargando]           = useState(true);
  const [guardando, setGuardando]         = useState(false);
  const [error, setError]                 = useState('');
  const [modalEliminar, setModalEliminar] = useState(null);
  const [categorias, setCategorias]       = useState(CATEGORIAS_DEFAULT);

  useEffect(() => { cargar(); cargarCategorias(); }, []);

  const cargar = async () => {
    setCargando(true);
    try {
      const [resActivos, resInactivos] = await Promise.all([
        axios.get(`${API}/proveedores`),
        axios.get(`${API}/proveedores?inactivos=true`)
      ]);
      setLista([
        ...resActivos.data.map(p => ({ ...p, activo: true })),
        ...resInactivos.data.map(p => ({ ...p, activo: false }))
      ]);
    } catch (e) { console.error(e); }
    setCargando(false);
  };

  const cargarCategorias = async () => {
    try {
      const res = await apiFetch(`${API}/listas?lista=categoria_proveedor`);
      if (!res.ok) throw new Error();
      const data = await res.json();
      if (data.length > 0) setCategorias(data.map(d => d.valor));
    } catch (e) { /* fallback */ }
  };

  const activos   = lista.filter(p => p.activo);
  const inactivos = lista.filter(p => !p.activo);
  const fuente    = vistaActivos ? activos : inactivos;

  const filtrados = fuente.filter(p =>
    [p.razon_social, p.cedula, p.categoria, p.nombre_contacto, p.banco]
      .some(v => (v||'').toLowerCase().includes(filtro.toLowerCase()))
  );

  const stats = {
    total:     activos.length,
    conCRC:    activos.filter(p => p.cuenta_crc || p.iban_crc).length,
    conUSD:    activos.filter(p => p.cuenta_usd || p.iban_usd).length,
    inactivos: inactivos.length,
  };

  const cerrarModal = () => {
    if (window.confirm('¿Salir sin guardar? Los cambios se perderán.')) setModal(false);
  };
  const abrirNuevo  = () => { setForm(EMPTY); setEditando(false); setError(''); setModal(true); };
  const abrirEditar = (p) => {
    setForm({
      ...EMPTY, ...p,
      cuenta_crc: p.cuenta_crc || '',
      iban_crc:   p.iban_crc   || '',
      cuenta_usd: p.cuenta_usd || '',
      iban_usd:   p.iban_usd   || '',
    });
    setEditando(true); setError(''); setModal(true); setDetalle(null);
  };

  const guardar = async () => {
    if (!form.razon_social?.trim()) { setError('La Razón Social es obligatoria.'); return; }
    if (!form.cedula?.trim())       { setError('La Cédula es obligatoria.'); return; }
    setGuardando(true); setError('');
    try {
      if (editando) await axios.put(`${API}/proveedores?id=${form.id}`, form);
      else          await axios.post(`${API}/proveedores`, form);
      setModal(false);
      await cargar();
    } catch (e) { setError('Error al guardar: ' + (e.response?.data?.error || e.message)); }
    finally { setGuardando(false); }
  };

  const desactivar = async (id) => {
    if (!window.confirm('¿Desactivar este proveedor? Podrá reactivarlo más adelante.')) return;
    try { await axios.delete(`${API}/proveedores?id=${id}`); await cargar(); }
    catch (e) { console.error(e); }
  };

  const reactivar = async (id) => {
    if (!window.confirm('¿Reactivar este proveedor?')) return;
    try { await axios.put(`${API}/proveedores?id=${id}`, { reactivar: true }); await cargar(); }
    catch (e) { console.error(e); }
  };

  const eliminar = async () => {
    if (!modalEliminar) return;
    try { await axios.delete(`${API}/proveedores?id=${modalEliminar.id}&hard=true`); setModalEliminar(null); await cargar(); }
    catch (e) { console.error(e); }
  };

  const f = (key, val) => setForm(prev => ({ ...prev, [key]: val }));

  const campo = (label, key, tipo='text', opciones=null, borderColor=null) => (
    <div style={{ display:'flex', flexDirection:'column', gap:'4px' }}>
      <label style={{ fontSize:'10px', color:'#888', fontWeight:'600', textTransform:'uppercase', letterSpacing:'0.5px' }}>{label}</label>
      {opciones
        ? <select value={form[key]||''} onChange={e => f(key, e.target.value)}
            style={{ ...inputStyle, borderColor: borderColor || '#e0e0e0' }}>
            <option value=''>— Seleccionar —</option>
            {opciones.map(o => <option key={o} value={o}>{o}</option>)}
          </select>
        : <input type={tipo} value={form[key]||''} onChange={e => f(key, e.target.value)}
            style={{ ...inputStyle, borderColor: borderColor || '#e0e0e0' }} />
      }
    </div>
  );

  // Sección bancaria con dos tarjetas coloreadas
  const seccionBancaria = () => (
    <div>
      <div style={{ fontSize:'11px', fontWeight:'700', color:'#012E40', textTransform:'uppercase', letterSpacing:'0.7px', marginBottom:'12px', paddingBottom:'6px', borderBottom:'2px solid #e8e8e8' }}>
        Datos bancarios
      </div>

      {/* Banco principal */}
      <div style={{ marginBottom:'16px' }}>
        {campo('Banco', 'banco', 'text', BANCOS)}
      </div>

      {/* Dos cuentas lado a lado */}
      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'12px' }}>

        {/* Cuenta Colones */}
        <div style={{ background:'#f0faf4', border:'1px solid #b8dfc8', borderRadius:'10px', padding:'14px' }}>
          <div style={{ display:'flex', alignItems:'center', gap:'7px', marginBottom:'12px' }}>
            <div style={{ width:'8px', height:'8px', borderRadius:'50%', background:'#2d6a2d' }}/>
            <span style={{ fontSize:'11px', fontWeight:'700', color:'#2d6a2d', textTransform:'uppercase', letterSpacing:'0.5px' }}>Cuenta en Colones</span>
          </div>
          <div style={{ display:'flex', flexDirection:'column', gap:'10px' }}>
            {campo('Número de cuenta', 'cuenta_crc', 'text', null, '#b8dfc8')}
            {campo('IBAN', 'iban_crc', 'text', null, '#b8dfc8')}
          </div>
        </div>

        {/* Cuenta Dólares */}
        <div style={{ background:'#eff5fd', border:'1px solid #b0cff0', borderRadius:'10px', padding:'14px' }}>
          <div style={{ display:'flex', alignItems:'center', gap:'7px', marginBottom:'12px' }}>
            <div style={{ width:'8px', height:'8px', borderRadius:'50%', background:'#185FA5' }}/>
            <span style={{ fontSize:'11px', fontWeight:'700', color:'#185FA5', textTransform:'uppercase', letterSpacing:'0.5px' }}>Cuenta en Dólares</span>
          </div>
          <div style={{ display:'flex', flexDirection:'column', gap:'10px' }}>
            {campo('Número de cuenta', 'cuenta_usd', 'text', null, '#b0cff0')}
            {campo('IBAN', 'iban_usd', 'text', null, '#b0cff0')}
          </div>
        </div>

      </div>
    </div>
  );

  return (
    <div style={{ padding:'24px', fontFamily:'Segoe UI, sans-serif', maxWidth:'1200px' }}>

      {/* Header */}
      <div style={{ background:'#012E40', borderRadius:'12px', padding:'16px 20px', marginBottom:'20px', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
        <div style={{ display:'flex', alignItems:'center', gap:'14px' }}>
          <span style={{ color:'#fff', fontSize:'17px', fontWeight:'700' }}>Proveedores</span>
          <div style={{ display:'flex', background:'rgba(255,255,255,0.1)', borderRadius:'20px', padding:'2px' }}>
            <button onClick={() => { setVistaActivos(true); setFiltro(''); }}
              style={{ padding:'4px 16px', border:'none', borderRadius:'20px', fontSize:'12px', fontWeight:'600', cursor:'pointer',
                background: vistaActivos ? '#fff' : 'transparent',
                color:      vistaActivos ? '#012E40' : 'rgba(255,255,255,0.6)' }}>
              Activos ({activos.length})
            </button>
            <button onClick={() => { setVistaActivos(false); setFiltro(''); }}
              style={{ padding:'4px 16px', border:'none', borderRadius:'20px', fontSize:'12px', fontWeight:'600', cursor:'pointer',
                background: !vistaActivos ? '#fff' : 'transparent',
                color:      !vistaActivos ? '#A32D2D' : 'rgba(255,255,255,0.6)' }}>
              Inactivos ({inactivos.length})
            </button>
          </div>
        </div>
        <button onClick={abrirNuevo} style={{ padding:'8px 16px', background:'#87B749', color:'#fff', border:'none', borderRadius:'8px', fontSize:'13px', fontWeight:'600', cursor:'pointer' }}>
          + Nuevo proveedor
        </button>
      </div>

      {/* Stats */}
      {vistaActivos && (
        <div style={{ display:'grid', gridTemplateColumns:'repeat(4, 1fr)', gap:'12px', marginBottom:'20px' }}>
          {[
            { label:'Total activos',   valor: stats.total,     color:'#012E40' },
            { label:'Con cuenta CRC',  valor: stats.conCRC,    color:'#2d6a2d' },
            { label:'Con cuenta USD',  valor: stats.conUSD,    color:'#185FA5' },
            { label:'Inactivos',       valor: stats.inactivos, color:'#A32D2D' },
          ].map(s => (
            <div key={s.label} style={{ background:'#fff', border:'1px solid #e8e8e8', borderRadius:'10px', padding:'14px 18px' }}>
              <div style={{ fontSize:'11px', color:'#888', fontWeight:'600', textTransform:'uppercase', letterSpacing:'0.5px' }}>{s.label}</div>
              <div style={{ fontSize:'26px', fontWeight:'700', color: s.color, marginTop:'4px' }}>{s.valor}</div>
            </div>
          ))}
        </div>
      )}

      {/* Buscador */}
      <div style={{ marginBottom:'16px', position:'relative' }}>
        <svg style={{ position:'absolute', left:'12px', top:'50%', transform:'translateY(-50%)', pointerEvents:'none' }} width="16" height="16" viewBox="0 0 20 20" fill="none">
          <circle cx="9" cy="9" r="6" stroke="#aaa" strokeWidth="1.5"/>
          <path d="M15 15l-3-3" stroke="#aaa" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
        <input value={filtro} onChange={e => setFiltro(e.target.value)}
          placeholder={`Buscar ${vistaActivos ? 'proveedores activos' : 'proveedores inactivos'}...`}
          style={{ ...inputStyle, paddingLeft:'38px', borderRadius:'10px', background:'#fff' }} />
      </div>

      {/* Tabla activos */}
      {vistaActivos && (
        <div style={{ background:'#fff', border:'1px solid #e8e8e8', borderRadius:'12px', overflow:'hidden' }}>
          {cargando ? (
            <div style={{ padding:'40px', textAlign:'center', color:'#888' }}>Cargando...</div>
          ) : filtrados.length === 0 ? (
            <div style={{ padding:'40px', textAlign:'center', color:'#bbb' }}>No se encontraron proveedores.</div>
          ) : (
            <table style={{ width:'100%', borderCollapse:'collapse', fontSize:'13px' }}>
              <thead>
                <tr style={{ background:'#f8f9fa' }}>
                  {['Razón Social','Cédula','Categoría','Banco','Cuentas','Acciones'].map(h => (
                    <th key={h} style={{ padding:'11px 14px', textAlign:'left', color:'#888', fontWeight:'600', fontSize:'11px', textTransform:'uppercase', letterSpacing:'0.5px', borderBottom:'1px solid #eee' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filtrados.map(p => (
                  <tr key={p.id} style={{ borderBottom:'1px solid #f3f3f3', cursor:'pointer' }}
                    onMouseEnter={e => e.currentTarget.style.background='#fafafa'}
                    onMouseLeave={e => e.currentTarget.style.background='transparent'}>
                    <td style={{ padding:'11px 14px', fontWeight:'600', color:'#1a1a1a' }}
                      onClick={() => setDetalle(detalle?.id === p.id ? null : p)}>
                      {p.razon_social}
                    </td>
                    <td style={{ padding:'11px 14px', color:'#555' }}>{p.cedula}</td>
                    <td style={{ padding:'11px 14px' }}>{catBadge(p.categoria)}</td>
                    <td style={{ padding:'11px 14px', color:'#555' }}>{p.banco || '—'}</td>
                    <td style={{ padding:'11px 14px' }}>
                      <div style={{ display:'flex', gap:'4px', flexWrap:'wrap' }}>
                        {(p.cuenta_crc || p.iban_crc) && (
                          <span style={{ background:'#f0faf4', color:'#2d6a2d', padding:'2px 8px', borderRadius:'8px', fontSize:'11px', fontWeight:'500' }}>CRC</span>
                        )}
                        {(p.cuenta_usd || p.iban_usd) && (
                          <span style={{ background:'#eff5fd', color:'#185FA5', padding:'2px 8px', borderRadius:'8px', fontSize:'11px', fontWeight:'500' }}>USD</span>
                        )}
                        {!p.cuenta_crc && !p.iban_crc && !p.cuenta_usd && !p.iban_usd && (
                          <span style={{ color:'#ccc', fontSize:'12px' }}>—</span>
                        )}
                      </div>
                    </td>
                    <td style={{ padding:'11px 14px' }}>
                      <div style={{ display:'flex', gap:'6px' }}>
                        <button onClick={() => abrirEditar(p)}
                          style={{ padding:'4px 12px', background:'none', border:'1px solid #ddd', borderRadius:'6px', fontSize:'12px', cursor:'pointer', color:'#555' }}>
                          Editar
                        </button>
                        <button onClick={() => desactivar(p.id)}
                          style={{ padding:'4px 12px', background:'none', border:'1px solid #ddd', borderRadius:'6px', fontSize:'12px', cursor:'pointer', color:'#999' }}>
                          Desactivar
                        </button>
                        {isAdmin && (
                          <button onClick={() => setModalEliminar(p)}
                            style={{ padding:'4px 12px', background:'none', border:'1px solid #fcc', borderRadius:'6px', fontSize:'12px', cursor:'pointer', color:'#A32D2D' }}>
                            Eliminar
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}

      {/* Tabla inactivos */}
      {!vistaActivos && (
        <div style={{ background:'#fff', border:'1px solid #e8e8e8', borderRadius:'12px', overflow:'hidden', borderTop:'3px solid #f5c6c6' }}>
          <div style={{ background:'#fdf3f3', padding:'10px 16px', display:'flex', alignItems:'center', justifyContent:'space-between', borderBottom:'1px solid #f5c6c6' }}>
            <span style={{ fontSize:'12px', color:'#A32D2D', fontWeight:'600' }}>
              Proveedores inactivos — {inactivos.length} registro{inactivos.length !== 1 ? 's' : ''}
            </span>
            <span style={{ fontSize:'11px', color:'#888' }}>
              {isAdmin ? 'Podés reactivar o eliminar permanentemente' : 'Solo admins pueden reactivar'}
            </span>
          </div>
          {cargando ? (
            <div style={{ padding:'40px', textAlign:'center', color:'#888' }}>Cargando...</div>
          ) : filtrados.length === 0 ? (
            <div style={{ padding:'40px', textAlign:'center', color:'#bbb' }}>
              {inactivos.length === 0 ? 'No hay proveedores inactivos.' : 'No se encontraron resultados.'}
            </div>
          ) : (
            <table style={{ width:'100%', borderCollapse:'collapse', fontSize:'13px' }}>
              <thead>
                <tr style={{ background:'#fdf8f8' }}>
                  {['Razón Social','Cédula','Categoría','Banco','Acciones'].map(h => (
                    <th key={h} style={{ padding:'11px 14px', textAlign:'left', color:'#bbb', fontWeight:'600', fontSize:'11px', textTransform:'uppercase', letterSpacing:'0.5px', borderBottom:'1px solid #f0e8e8' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filtrados.map(p => (
                  <tr key={p.id} style={{ borderBottom:'1px solid #faf0f0', opacity:0.8 }}>
                    <td style={{ padding:'11px 14px', color:'#999', fontWeight:'500', textDecoration:'line-through' }}>{p.razon_social}</td>
                    <td style={{ padding:'11px 14px', color:'#bbb' }}>{p.cedula}</td>
                    <td style={{ padding:'11px 14px' }}>
                      <span style={{ background:'#f5f5f5', color:'#aaa', padding:'2px 8px', borderRadius:'8px', fontSize:'11px' }}>{p.categoria || '—'}</span>
                    </td>
                    <td style={{ padding:'11px 14px', color:'#bbb' }}>{p.banco || '—'}</td>
                    <td style={{ padding:'11px 14px' }}>
                      <div style={{ display:'flex', gap:'6px' }}>
                        {isAdmin && (
                          <button onClick={() => reactivar(p.id)}
                            style={{ padding:'4px 14px', background:'#012E40', color:'#fff', border:'none', borderRadius:'6px', fontSize:'12px', fontWeight:'600', cursor:'pointer' }}>
                            Reactivar
                          </button>
                        )}
                        {isAdmin && (
                          <button onClick={() => setModalEliminar(p)}
                            style={{ padding:'4px 12px', background:'none', border:'1px solid #fcc', borderRadius:'6px', fontSize:'12px', cursor:'pointer', color:'#A32D2D' }}>
                            Eliminar
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}

      {/* Panel detalle */}
      {detalle && vistaActivos && (
        <div style={{ marginTop:'16px', background:'#fff', border:'1px solid #e8e8e8', borderRadius:'12px', padding:'20px' }}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'16px' }}>
            <h3 style={{ margin:0, fontSize:'15px', fontWeight:'700', color:'#012E40' }}>{detalle.razon_social}</h3>
            <button onClick={() => setDetalle(null)} style={{ background:'none', border:'none', fontSize:'18px', cursor:'pointer', color:'#999' }}>✕</button>
          </div>

          {/* Datos generales */}
          <div style={{ display:'grid', gridTemplateColumns:'repeat(3, 1fr)', gap:'12px', fontSize:'13px', marginBottom:'16px' }}>
            {[
              ['Cédula',             detalle.cedula],
              ['Categoría',          detalle.categoria],
              ['Teléfono',           detalle.telefono],
              ['Correo comprobante', detalle.correo_comprobante],
              ['Contacto',           detalle.nombre_contacto],
              ['Correo contacto',    detalle.correo_contacto],
              ['Teléfono contacto',  detalle.telefono_contacto],
              ['Dirección',          detalle.direccion],
            ].map(([k,v]) => (
              <div key={k}>
                <div style={{ fontSize:'10px', color:'#aaa', fontWeight:'600', textTransform:'uppercase', letterSpacing:'0.5px' }}>{k}</div>
                <div style={{ color:'#333', marginTop:'2px' }}>{v || '—'}</div>
              </div>
            ))}
          </div>

          {/* Cuentas bancarias */}
          <div style={{ borderTop:'1px solid #f0f0f0', paddingTop:'14px' }}>
            <div style={{ fontSize:'10px', color:'#aaa', fontWeight:'700', textTransform:'uppercase', letterSpacing:'0.7px', marginBottom:'10px' }}>
              Banco: {detalle.banco || '—'}
            </div>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'10px' }}>

              <div style={{ background:'#f0faf4', border:'1px solid #b8dfc8', borderRadius:'8px', padding:'12px' }}>
                <div style={{ fontSize:'10px', fontWeight:'700', color:'#2d6a2d', textTransform:'uppercase', letterSpacing:'0.5px', marginBottom:'8px' }}>Cuenta en Colones</div>
                <div style={{ fontSize:'12px', color:'#555', marginBottom:'4px' }}>
                  <span style={{ color:'#aaa', fontSize:'10px' }}>N° cuenta: </span>{detalle.cuenta_crc || '—'}
                </div>
                <div style={{ fontSize:'12px', color:'#555' }}>
                  <span style={{ color:'#aaa', fontSize:'10px' }}>IBAN: </span>{detalle.iban_crc || '—'}
                </div>
              </div>

              <div style={{ background:'#eff5fd', border:'1px solid #b0cff0', borderRadius:'8px', padding:'12px' }}>
                <div style={{ fontSize:'10px', fontWeight:'700', color:'#185FA5', textTransform:'uppercase', letterSpacing:'0.5px', marginBottom:'8px' }}>Cuenta en Dólares</div>
                <div style={{ fontSize:'12px', color:'#555', marginBottom:'4px' }}>
                  <span style={{ color:'#aaa', fontSize:'10px' }}>N° cuenta: </span>{detalle.cuenta_usd || '—'}
                </div>
                <div style={{ fontSize:'12px', color:'#555' }}>
                  <span style={{ color:'#aaa', fontSize:'10px' }}>IBAN: </span>{detalle.iban_usd || '—'}
                </div>
              </div>

            </div>
          </div>
        </div>
      )}

      {/* Modal formulario */}
      {modal && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.4)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000, padding:'20px' }}>
          <div style={{ background:'#fff', borderRadius:'16px', width:'100%', maxWidth:'720px', maxHeight:'90vh', display:'flex', flexDirection:'column', overflow:'hidden' }}>

            <div style={{ background:'#012E40', padding:'16px 24px', display:'flex', justifyContent:'space-between', alignItems:'center', flexShrink:0 }}>
              <span style={{ color:'#fff', fontSize:'15px', fontWeight:'700' }}>{editando ? 'Editar proveedor' : 'Nuevo proveedor'}</span>
              <button onClick={cerrarModal} style={{ background:'none', border:'none', color:'rgba(255,255,255,0.7)', fontSize:'22px', cursor:'pointer', lineHeight:1 }}>✕</button>
            </div>

            <div style={{ overflowY:'auto', padding:'24px', display:'flex', flexDirection:'column', gap:'20px' }}>

              {error && (
                <div style={{ background:'#FCEBEB', border:'1px solid #f5c6c6', borderRadius:'8px', padding:'10px 14px', fontSize:'13px', color:'#A32D2D' }}>
                  {error}
                </div>
              )}

              {/* Datos generales */}
              <div>
                <div style={{ fontSize:'11px', fontWeight:'700', color:'#012E40', textTransform:'uppercase', letterSpacing:'0.7px', marginBottom:'12px', paddingBottom:'6px', borderBottom:'2px solid #e8e8e8' }}>
                  Datos generales
                </div>
                <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'12px' }}>
                  {campo('Razón Social *', 'razon_social')}
                  {campo('Cédula / RUC *', 'cedula')}
                  {campo('Categoría', 'categoria', 'text', categorias)}
                  {campo('Teléfono', 'telefono')}
                  {campo('Correo comprobante', 'correo_comprobante', 'email')}
                  <div style={{ gridColumn:'1/-1' }}>{campo('Dirección', 'direccion')}</div>
                </div>
              </div>

              {/* Contacto */}
              <div>
                <div style={{ fontSize:'11px', fontWeight:'700', color:'#012E40', textTransform:'uppercase', letterSpacing:'0.7px', marginBottom:'12px', paddingBottom:'6px', borderBottom:'2px solid #e8e8e8' }}>
                  Contacto
                </div>
                <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:'12px' }}>
                  {campo('Nombre contacto', 'nombre_contacto')}
                  {campo('Correo contacto', 'correo_contacto', 'email')}
                  {campo('Teléfono contacto', 'telefono_contacto', 'tel')}
                </div>
              </div>

              {/* Datos bancarios */}
              {seccionBancaria()}

            </div>

            <div style={{ padding:'16px 24px', borderTop:'1px solid #eee', display:'flex', justifyContent:'flex-end', gap:'10px', flexShrink:0 }}>
              <button onClick={cerrarModal} style={{ padding:'9px 20px', border:'1px solid #e0e0e0', borderRadius:'8px', background:'#fff', cursor:'pointer', fontSize:'13px' }}>
                Cancelar
              </button>
              <button onClick={guardar} disabled={guardando}
                style={{ padding:'9px 24px', background:'#012E40', color:'#fff', border:'none', borderRadius:'8px', fontSize:'13px', fontWeight:'600', cursor:'pointer', opacity: guardando ? 0.7 : 1 }}>
                {guardando ? 'Guardando...' : (editando ? 'Guardar cambios' : 'Crear proveedor')}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal eliminar */}
      {modalEliminar && (
        <ModalEliminar
          proveedor={modalEliminar}
          onConfirm={eliminar}
          onCancel={() => setModalEliminar(null)}
        />
      )}
    </div>
  );
}
